export const NAME = 'contentCodes';

export const UPDATE_CODE_FORM = 'updateCodeForm';
export const ADD_CODE_FORM = 'addCodeForm';